import { render } from "./OperationsHealth.vue?vue&type=template&id=16a53503&scoped=true"
import script from "./OperationsHealth.vue?vue&type=script&lang=js"
export * from "./OperationsHealth.vue?vue&type=script&lang=js"

import "./OperationsHealth.vue?vue&type=style&index=0&id=16a53503&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a53503"]])

export default __exports__